import { useApiQuery } from "app/modules/api-client";
import DurationService from "app/services/DurationService";

import { useDisplayAdvertiserPublisherDataAndParams } from "../../hooks/useDisplayAdvertiserPublisherDataAndParams";

export interface IFormatShare {
    video?: number;
    banner?: number;
    native?: number;
}

export const useFormatBreakdown = () => {
    const params = useDisplayAdvertiserPublisherDataAndParams();
    const { from, to, isWindow } = DurationService.getDurationData(params.duration).forAPI;

    return useApiQuery(
        {
            tag: "AdIntelligenceMarketingAssets",
            methodName: "adIntelligenceAdvertiserFormatDataList",
        },
        {
            country: params.country,
            key: params.key.split(","),
            from,
            to,
            isWindow,
        },
    );
};
